export const CUSTOM_FIELD_CONFIG = {
    MAX_PARENT_FIELD_COUNT: 5
} as const;